import { OnlineTicketUsageBoard } from '@kinderlabs-pos/feature/pos/online-tickets';
import { OrderState, StoreInfoState } from '@kinderlabs-pos/state';
import { DatePicker, WithDialog, XlDialogProps } from '@kinderlabs-pos/ui-atoms';
import { useConfirm } from '@kinderlabs-pos/ui-components';
import { Button, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

const today = dayjs();
export interface OnlineTicketKyulsanDialogProps extends XlDialogProps {}

/**
 * 온라인권 결산주문 (슈퍼유저 수동 사용처리)
 * - 온라인권을 검색해 카트에 담고, 벤더 API 호출 없이 DB 사용완료 처리 + 카트라인 저장.
 * - 결제 단계 없음.
 */
export const OnlineTicketKyulsanDialog = ({ open, closeDialog }: OnlineTicketKyulsanDialogProps) => {
	const [targetDate, setTargetDate] = useState(today);

	const { storeId, deviceId: posId } = useAtomValue(StoreInfoState.curStoreAndDevice);
	const { cart } = useAtomValue(OrderState.value);
	const settle = OrderState.actions.useOnlineTicketKyulsanSettleOrder();
	const customConfirm = useConfirm();

	const onlineTicketLineCount = cart.lines.filter(
		(cl) => cl.type === 'ONLINE_TICKET_ONOFFMIX'
	).length;

	const handleSubmit = () => {
		customConfirm(
			<Typography
				variant={'h3'}
				color='text.primary'>
				{`온라인권 ${onlineTicketLineCount}건을 벤더 연동 없이 수동 결산 처리합니다. 진행하시겠습니까?`}
			</Typography>,
			async () => {
				await settle.mutateAsync(
					{ storeId, posId, targetDate },
					{ onSuccess: () => closeDialog && closeDialog() }
				);
			}
		);
	};

	return (
		<WithDialog.XlDialog
			open={open}
			scroll='body'
			closeDialog={closeDialog}
			dialogTitle={'온라인권 결산주문 (수동 사용처리)'}>
			<DialogContent>
				<Stack
					spacing={2}
					py={2}
					height={640}>
					<Stack width={400}>
						<DatePicker
							label={<Typography variant={'h4'}>{'결산 대상일'}</Typography>}
							value={targetDate}
							minDate={today.add(-1, 'year')}
							maxDate={today}
							onChange={(value) => {
								if (value) setTargetDate(value);
							}}
							usageType={'POS'}
						/>
					</Stack>
					<Typography
						variant={'body2'}
						color='text.secondary'>
						{'아래에서 온라인권을 검색해 카트에 추가한 뒤 결산 처리하세요. (벤더 API 미호출)'}
					</Typography>
					<Stack
						flex={1}
						overflow={'auto'}>
						<OnlineTicketUsageBoard />
					</Stack>
					<Typography variant={'subtitle1'}>
						{`카트에 담긴 온라인권: ${onlineTicketLineCount}건`}
					</Typography>
				</Stack>
				<DialogActions>
					<Button onClick={closeDialog}>{'닫기'}</Button>
					<Button
						variant={'contained'}
						disabled={onlineTicketLineCount === 0 || settle.isLoading}
						onClick={handleSubmit}>
						{'결산 처리'}
					</Button>
				</DialogActions>
			</DialogContent>
		</WithDialog.XlDialog>
	);
};
